import {LogLevel} from '../app/core/log/log-level.enum';
import {customer} from '@env/customer';

const packageJson = require('../../package.json');

const defaultDatahubHost = 'my-devci.poc.learning.amplify.com/admin-portal/enrollment/upload/internal/api';
const defaultDataApiHost = 'my-devci.poc.learning.amplify.com/admin-portal/enrollment/upload/internal/api';
const defaultEtxHost = 'sso.gg4l.com';

// const defaultDatahubHost = 'sp-gg4l-dev-api.edutone.net';
// const defaultDataApiHost = 'sp-gg4l-dev-api.edutone.net';
// const defaultEtxHost = 'sp-etx-dev.edutone.net';

// const defaultDatahubHost = 'sp-gg4l-qa-api.edutone.net';
// const defaultDataApiHost = 'sp-gg4l-qa-api.edutone.net';
// const defaultEtxHost = 'sp-etx-qa.edutone.net';

// const defaultDatahubHost = 'connect-qa-my-devci.poc.learning.amplify.com/admin-portal/enrollment/upload/internal/api';
// const defaultDataApiHost = 'connect-qa-my-devci.poc.learning.amplify.com/admin-portal/enrollment/upload/internal/api';
// const defaultEtxHost = 'etx-qa.gg4l.com';

// const defaultDatahubHost = 'oneroster-my-devci.poc.learning.amplify.com/admin-portal/enrollment/upload/internal/api';
// const defaultDataApiHost = 'oneroster-my-devci.poc.learning.amplify.com/admin-portal/enrollment/upload/internal/api';
// const defaultEtxHost = 'etx-stage.gg4l.com';

const defaultMixpanelToken = '2149ac4f57559b21620aa3a36a88c8a6';

const datahubHost = (customer.hasOwnProperty('datahubHost') ? customer['datahubHost'] : defaultDatahubHost);
const dataApiHost = (customer.hasOwnProperty('dataApiHost') ? customer['dataApiHost'] : defaultDataApiHost);
const etxHost = (customer.hasOwnProperty('etxHost') ? customer['etxHost'] : defaultEtxHost);
const mixpanelToken = (customer.hasOwnProperty('mixpanelToken') ? customer['mixpanelToken'] : defaultMixpanelToken);

if (!customer['sftpHost']) {
    customer['sftpHost'] = datahubHost;
}

export const environment = {
    production: false,
    maintenance: false,
    datahubHost: `https://${datahubHost}`,
    datahubBaseURI: `https://${datahubHost}/datahub`,
    dataApiBaseURI: `https://${dataApiHost}`,
    ltiPlatformBaseURI: `https://${dataApiHost}`,
    etxBaseURI: etxHost ? `https://${etxHost}` : null,
    stsServer: etxHost ? `https://${etxHost}/account` : null,
    spOidcClientId: etxHost ? 'gg4l-pub' : null,
    mixpanelToken: mixpanelToken,

    privateIdApiUrl: 'https://api.prodv2.cryptonets.ai/node',
    privateIdApiKey: 'gg4l30dca3894df2cb23',

    customer: customer,
    version: packageJson.version,

    log: {
        // Only log messages with a severity equal or higher than this can be logged.
        level: LogLevel.ALL,
        // If the severity of the log message is equal or greater than this, but smaller than level,
        // the log message will not be sent to the server, but stored in an internal buffer.
        // If bufferSize is 0 or less, the log message is simply ignored.
        storeInBufferLevel: LogLevel.ALL,
        // If the severity of a log message is equal or greater than this,
        // not only the log message but also all log messages stored in the internal buffer will be sent to the server.
        // This allows you to store low priority trace messages in the internal buffer,
        // and only send them when a high priority fatal message is sent.
        sendWithBufferLevel: LogLevel.ERROR,
        // Sets the size of the buffer used with sendWithBufferLevel and storeInBufferLevel.
        bufferSize: 5,
        debounceTime: 5000,
        serverLoggingUrl: `https://${datahubHost}/datahub/logs`
    },
    // ToDo: Need to change restrictedSyncLocalHour every last Sunday of October and March for Winter Time (Kyiv) - 12, for Summer Time (Kyiv) - 11
    restrictedSyncLocalHour: 12 - new Date().getTimezoneOffset() / 60, // 14:00 hour Eastern European Summer Time (Kyiv)
    restrictedSyncDuration: 0 // hours
};
